import React from 'react';

const InputError = ({ touched, message }) => {
  if (!touched) {
    return <div className="invalid-feedback">&nbsp;</div>;
  }
  if (message) {
    return <div className="invalid-feedback">{message}</div>;
  }
  return <></>;
};

export default InputError;
